<div class="body-main"> 
  <div class="body-main-top">  
	<div class="py-2">
		<div class="container">
		  <div class="row">
			<div class="col-md-12 py-1">
				<form (ngSubmit)="onSubmit(roleForm, model._id)" #roleForm="ngForm">
				<div class="form-group"> <label for="accountName">Role Name</label>
				  <input type="text" required class="form-control" id="role" placeholder="Enter Role Name" name="role" #role="ngModel" [(ngModel)]="model.role"> 
				  <div *ngIf="Response" class="alert alert-danger">{{Response}}</div> 
				</div>
				<button type="submit" class="btn btn-primary pull-right">{{ (model._id)?"Update":"Create" }}</button>
			  </form>
			</div>
		  </div>
		</div>
	</div>
  </div>
</div>